module.exports = __webpack_public_path__ + "static/media/NewEdit.35f0364e.svg";